import { Combobox } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

// Mirrors `ScDynamicSelect`'s caret exactly (same icon, same rotate-on-open animation) so every
// select-family control in the form editor looks and behaves the same. Mantine's Select/
// MultiSelect only swap in *their own* default chevron when no `rightSection` prop is supplied at
// all (InputBase resolves an explicit `rightSection` ahead of its `__clearable`/
// `__defaultRightSection` fallbacks regardless of what it's given) — so matching the icon means
// taking over that whole slot, clear button included. `Combobox.ClearButton` is Mantine's own
// clear-button implementation, reused as-is so clearing still looks and behaves exactly like it
// would have without this override.
export interface SelectCaretProps {
    dropdownOpened: boolean;
    showClear: boolean;
    onClear: () => void;
}

export function SelectCaret({ dropdownOpened, showClear, onClear }: SelectCaretProps) {
    if (showClear) {
        return <Combobox.ClearButton onClear={onClear} />;
    }
    return (
        <IconChevronDown
            size="1.3em"
            style={{
                transform: `rotate(${dropdownOpened ? -180 : 0}deg)`,
                transition: '40ms ease-in-out',
                color: 'var(--mantine-color-gray-7)',
            }}
        />
    );
}
